import { ChangeDetectionStrategy, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { TableParagraphEditorComponent } from '@blaze-runtime/engine-feature';

import { BaseCellInputComponent } from '../base-cell-input.component';

@UntilDestroy()
@Component({
  selector: 'blaze-cell-input-text-multi-line',
  template: `<div class="paragraph-expand-container">
      <div class="paragraph-expand" (click)="openParagraph($event)">
        <mat-icon svgIcon="arrow_forward" />
      </div>
    </div>
    <textarea
      #stringInput
      rows="1"
      [formControl]="formControl"
      [class.readonly]="column.isComputed"
      [attr.readonly]="column.isComputed ? true : null"
      class="input-string h-full resize-none"
    >
    </textarea>`,
  styleUrls: ['./cell-input-text-multi-line.component.scss', '../base-cell-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatIcon],
})
export class CellInputTextMultiLineComponent extends BaseCellInputComponent<string> {
  private readonly dialog = inject(MatDialog);

  @ViewChild('stringInput') stringInputRef!: ElementRef<HTMLTextAreaElement>;

  private paragraphDialog?: MatDialogRef<TableParagraphEditorComponent>;

  override get nativeElement(): HTMLTextAreaElement | null {
    return this.stringInputRef?.nativeElement || null;
  }

  openParagraph(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.paragraphDialog = this.dialog.open(TableParagraphEditorComponent, {
      width: '50%',
      height: 'auto',
      hasBackdrop: true,
      panelClass: ['bd', 'bd-dialog', 'inline-editor-paragraph-editor'],
      maxWidth: '440px',
      data: {
        value: this.formControl.value,
        columnLabel: this.column.name,
      },
    });

    this.paragraphDialog
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe((val: string) => {
        this.formControl.patchValue(val);
        this.value = val;
        this.emitValueChanged(val);
      });
  }
}
